import * as React from 'react';
import { Link } from 'react-router';
import { SiteRoute } from '@journeyapps/package-types';
import { AnimatePresence } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { S } from './styles';
import { CustomerLogos } from '../CustomerLogos';

interface StoryWelcomeProps {
  visible: boolean;
  reducedMotion: boolean;
  onStart: () => void;
}

export const StoryWelcome: React.FC<StoryWelcomeProps> = ({ visible, reducedMotion, onStart }) => (
  <AnimatePresence initial={false}>
    {visible && (
      <S.StoryIntro
        key="welcome"
        exit={{ opacity: 0, scale: reducedMotion ? 1 : 0.88, y: reducedMotion ? 0 : -50 }}
        transition={{ duration: reducedMotion ? 0 : 0.65 }}
      >
        <S.Eyebrow>MEET JOURNEYAPPS PLATFORM</S.Eyebrow>
        <h1>
          The ultimate system
          <br />
          to build <em>almost anything.</em>
        </h1>
        <p>
          Build applications. Automate business processes. Connect existing systems.
          <br />
          One foundation for your data, code, and everything that comes next.
        </p>
        <S.StartButton type="button" onClick={onStart}>
          Start the walkthrough <FontAwesomeIcon icon={faArrowRight} />
        </S.StartButton>
        <S.IntroCustomers>
          <CustomerLogos />
          <span>
            Trusted by teams building mission-critical applications. <Link to={SiteRoute.CUSTOMERS}>Learn more</Link>
          </span>
        </S.IntroCustomers>
      </S.StoryIntro>
    )}
  </AnimatePresence>
);
